import { useOneNumberInput } from './oneNumberInput.hook';
import { IOneNumberInput } from './oneNumberInput.models';
import * as S from './oneNumberInput.style';

export const OneNumberInput: React.FC<IOneNumberInput> = ({
  focusedRef,
  error,
  onOtpBlur,
  onOtpChange,
  otpRef,
  readOnly,
  cursor = 'pointer',
  ...rest
}) => {
  const { handleBlur, handleFocus, inputRef, handleKeyDown, validate } = useOneNumberInput({
    focusedRef,
    onOtpBlur,
    onOtpChange,
    otpRef,
  });

  return (
    <S.Input
      {...rest}
      error={error}
      onBlur={handleBlur}
      onChange={validate}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      placeholder="0"
      ref={inputRef}
      type="number"
      readOnly={readOnly}
      className="otp"
      autoComplete="one-time-code"
      style={{ cursor }} 
    />
  );
};
